var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlumiPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.741 4.88809C26.0394 5.38009 24.4162 6.11929 22.7138 6.60729C19.3786 7.56329 15.8514 7.52969 12.4122 7.98329C8.97297 8.43689 5.39617 9.50729 3.10897 12.1153C0.136171 15.5049 0.167372 20.8673 2.44417 24.7585C4.72097 28.6497 8.84177 31.1849 13.1602 32.4809C16.7298 33.5521 20.5594 33.8713 24.2082 33.1129C27.857 32.3545 31.3114 30.4785 33.721 27.6361C35.405 25.6497 36.5426 23.2593 37.485 20.8321C38.6874 17.7345 39.613 14.3801 39.0146 11.1113C37.977 5.44809 32.905 3.39449 27.741 4.88809Z",
    fill: "#F8BEC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1777 33.1792C35.6018 33.1792 35.9457 32.8353 35.9457 32.4112C35.9457 31.987 35.6018 31.6432 35.1777 31.6432C34.7535 31.6432 34.4097 31.987 34.4097 32.4112C34.4097 32.8353 34.7535 33.1792 35.1777 33.1792Z",
    fill: "#FDCB4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81689 35.2601C1.81689 34.8361 2.16009 34.4921 2.58489 34.4921C3.00969 34.4921 3.35289 34.8353 3.35289 35.2601C3.35289 35.6849 3.00969 36.0281 2.58489 36.0281C2.16009 36.0281 1.81689 35.6849 1.81689 35.2601Z",
    fill: "#781BFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7353 1.67443C32.1594 1.67443 32.5033 1.33058 32.5033 0.906428C32.5033 0.482273 32.1594 0.138428 31.7353 0.138428C31.3111 0.138428 30.9673 0.482273 30.9673 0.906428C30.9673 1.33058 31.3111 1.67443 31.7353 1.67443Z",
    fill: "#4CB648"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11095_970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 19C32 16.955 30.763 15.197 29 14.424V12.037L11.997 12C11.651 12 11.321 11.942 11 11.859V22C11 22.551 11.449 23 12 23H21.026C20.391 23.838 20 24.87 20 26H12C9.794 26 8 24.206 8 22V8C8 5.778 9.781 4.021 12.056 4H32V7H12.069C11.465 7.005 11 7.436 11 8C11 8.551 11.449 9 12 9L32.003 9.043L32 19ZM29 23H25C23.346 23 22 24.346 22 26V28H32V26C32 24.346 30.654 23 29 23ZM30 19C30 17.346 28.654 16 27 16C25.346 16 24 17.346 24 19C24 20.654 25.346 22 27 22C28.654 22 30 20.654 30 19Z",
    fill: "#744747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11095_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumiPortal);
export default __webpack_public_path__ + "static/media/alumi-portal.29934aee727eb5677f5baf3e3758f5e8.svg";
export { ForwardRef as ReactComponent };